enum AUTH_LOCAL_STORAGES {
  token = 'token',
  refreshToken = 'refreshToken',
  user = 'user',
  refreshTokenTimeout = 'refreshTokenTimeout',
}
export default AUTH_LOCAL_STORAGES;
